import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { SettlementsService } from 'src/app/services/settlements.service';
import { Router, ActivatedRoute } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { Role } from 'src/app/models/role.model';
import { User } from 'src/app/models/user';

@Component({
  selector: 'app-user-create',
  template: `
    <div class="d-flex mt-0 mt-md-4">
      <div class="flex-fill">
        <h1 class="mt-2 mt-md-0">Perfiles y roles</h1>
      </div>
    </div>
    <div class="d-flex mt-4">
      <div class="me-3 d-none d-md-block">
        <ul #subnav app-nav-administration [currentView]="currentView" class="sidebar-zazz list-unstyled"></ul>
      </div>
      <div class="flex-fill" style="max-width: 380px;">        
        <div class="list-group rounded-4 rounded-md-5">
          <div class="list-group-item table-responsive py-4">
            <app-form-user 
              [user]="user" 
              [roles]="roles" 
              (updateUser)="saveUser($event)"
            ></app-form-user>
          </div>
        </div>
      </div>
    </div>
  `,
  styleUrls: []
})
export class UserCreateComponent implements OnInit {
  userId: number = 0;
  user: User | null = null;
  roles: Role[] = [];

  currentView: string = 'users';

  constructor(
    private store: SettlementsService,
    private route: Router,
    private activateRoute: ActivatedRoute,
    private fb: FormBuilder,
    private toastr: ToastrService
  ) { 
    this.activateRoute.params.subscribe(params => {
      this.userId = params['id'];
      this.loadUser(this.userId);
    });

    this.store.getRoles({}).subscribe({
      next: (data: any) => {
        this.roles = data;
      },
      error: (error: any) => {}
    });
  }
  
  ngOnInit(): void {}

  loadUser(id: number) {
    this.store.getTechnician(id).subscribe({
      next: (data: any) => {
        this.user = data;
      },
      error: (error: any) => {}
    });
  }

  saveUser(user: any) {
    this.store.createUser(user).subscribe({
      next: (data: any) => {
        this.toastr.success('Éxito', 'Usuario actualizado correctamente.');
      },
      error: (error: any) => {
        console.error(error);
        this.toastr.error('Error', 'Ocurrió un error al actualizar el usuario');
      }
    });
  }
}
